// extracted by mini-css-extract-plugin
export default {"container":"page-supplier-selection_container__MYDbv"};